<div class="body">

    <div class="headline">{{headline}}</div>

    <div class="content">

        <ng-container *ngFor="let subTitle of subTitles">

            <div class="sub-title">{{subTitle}}</div>

        </ng-container>

    </div>

</div>